/**
 * Validate a variable name according to JavaScript identifier rules.
 * - Must start with a letter, underscore, or dollar sign
 * - Can contain letters, numbers, underscores, and dollar signs
 * - Maximum length of 64 characters
 * - Cannot be a reserved keyword
 */
export function validateVariableName(name: string): boolean {
    // Check if name is empty or too long
    if (!name || name.length > 64) {
        return false;
    }

    // Check if it starts with a valid character (letter, underscore, or dollar sign)
    if (!/^[a-zA-Z_$]/.test(name)) {
        return false;
    }

    // Check if the rest of the name contains only valid characters
    return /^[a-zA-Z_$][a-zA-Z0-9_$]*$/.test(name);
}

/**
 * Get the type of a variable value.
 */
export function getVariableValueType(value: unknown): 'string' | 'number' | 'boolean' {
    if (typeof value === 'string') {
        return 'string';
    }

    if (typeof value === 'number') {
        return 'number';
    }

    if (typeof value === 'boolean') {
        return 'boolean';
    }

    return 'string';
}
